import { Module } from '@rxdi/core';
import { HttpModule as GithubHttpModule } from '@rxdi/http';
import { ResponsiveService } from '@rxdi/ui-components/services';
import { SocialModule } from '@stradivario/graphql-server';
import { MarkdownReaderModule } from '@stradivario/markdown';
import { AppsService } from '@stradivario/swiper';

import AR from './i18n/ar.json';
import BG from './i18n/bg.json';
import DE from './i18n/de.json';
import EN from './i18n/en.json';
import ES from './i18n/es.json';
import FR from './i18n/fr.json';
import NL from './i18n/nl.json';
import SR from './i18n/sr.json';
import TR from './i18n/tr.json';
import { OnlineStatusService } from './online-status/online-status.service';
import { PortalProvider } from './portal/portal.service';
import { PrefetchService } from './prefetch/prefetch.service';
import { BoardService } from './services/board/board.service';
import { CardService } from './services/card/card.service';
import { CLIService } from './services/cli/cli.service';
import { DateTimeProvider } from './services/date-time/date-time.service';
import { FooterService } from './services/footer/footer.service';
import { GithubService } from './services/github/github.service';
import { GlobalProjectsMenuService } from './services/global-projects-menu/global-projects-menu.service';
import { GraphEnumsProvider } from './services/graph-enums/graph-enums.provider';
import { HotKeysProvider } from './services/hotkeys/hotkeys.service';
import { HttpModule } from './services/http/http.module';
import { LambdaService } from './services/lambda/lambda.service';
import { LocalStorageService } from './services/local-storage/local-storage.service';
import { ModalProvider } from './services/modal/modal.provider';
import { NavMenuProvider } from './services/nav-menu/nav-menu.service';
import { NavbarItemsProvider } from './services/navbar-items/navbar-items';
import { NotificationsService } from './services/notifications/notifications.service';
import { MachineStartedTemplateComponent, MachineStoppedTemplateComponent } from './services/notifications/templates';
import { ProjectInviteTemplateComponent } from './services/notifications/templates/invite-project.template.component';
import { ProjectRemoveTemplateComponent } from './services/notifications/templates/remove-project.template.component';
import { ProjectsService } from './services/projects/projects.service';
import { StorageProvider } from './services/storage/storage.provider';
import { TeamsService } from './services/teams/teams.service';
import { UIComponentsService } from './services/ui-components/ui-components.service';
import { UserScopeService } from './services/user/user.scope.service';
import { UserService } from './services/user/user.service';
import { VSCodeService } from './services/vscode/vscode.service';
import { TranslationsModule } from './translate';
import { VersionService } from './version/version.service';
import { VerticalTimelineModule } from './vertical-timeline/vertical-timeline.module';

@Module({
  imports: [
    MarkdownReaderModule,
    HttpModule.forRoot({ url: 'http://localhost:9000/graphql' }),
    GithubHttpModule.forRoot({ url: 'https://api.github.com/graphql' }),

    VerticalTimelineModule,
    TranslationsModule.forRoot({
      translations: { EN, BG, AR, DE, FR, NL, SR, TR, ES },
    }),
  ],
  providers: [
    ResponsiveService,
    ProjectsService,
    TeamsService,
    UserService,
    CLIService,
    UIComponentsService,
    FooterService,
    PrefetchService,
    VersionService,
    DateTimeProvider,
    NotificationsService,
    GraphEnumsProvider,
    NavMenuProvider,
    HotKeysProvider,
    ModalProvider,
    LocalStorageService,
    GithubService,
    VSCodeService,
    CardService,
    BoardService,
    AppsService,
    UserScopeService,
    GlobalProjectsMenuService,
    NavbarItemsProvider,
    StorageProvider,
    OnlineStatusService,
    PortalProvider,
    LambdaService,
  ],
  plugins: [],
  components: [
    ProjectInviteTemplateComponent,
    ProjectRemoveTemplateComponent,
    MachineStartedTemplateComponent,
    MachineStoppedTemplateComponent,
  ],
})
export class CoreModule {}
